import { SETTING_TYPE } from 'pages/module/constant';
import { addAllToOptions } from 'utils/common';
import * as yup from 'yup'

export const settingFieldSchema = (type) => {
  switch (type) {
    case SETTING_TYPE.COMPANY:
      return yup.object({
        RefCode: yup.string().nullable().required()
      })
    default:
      return yup.object()
  }
}

export const settingFields = ({ t, isNew, currentSettingType, rifdList, bcTypeOptions, companyTypeOptions }) => {
  switch (currentSettingType) {
    case SETTING_TYPE.CATEGORY:
    case SETTING_TYPE.SUBCATEGORY:
      return [
        {
          label: t('BC_TYPE'),
          id: 'Bctype',
          type: 'select',
          options: bcTypeOptions,
          fieldProps: {
            disabled: !isNew
          }
        },
        {
          label: t('CATEGORY'),
          id: 'Category',
          fieldProps: {
            disabled: !isNew
          }
        },
        {
          label: t('DESC'),
          id: 'DescEN'
        },
        {
          label: t('DESC_TC'),
          id: 'DescTC'
        },
        {
          label: t('DESC_SC'),
          id: 'DescSC'
        },
        {
          label: t('SORT'),
          id: 'Sort',
          fieldProps: {
            type: 'number'
          }
        },
        {
          label: t('ISDEFAULT'),
          id: 'IsDefault',
          type: 'checkbox'
        }
      ];
    case SETTING_TYPE.COMPANY:
      return [
        {
          label: t('TYPE'),
          id: 'Type',
          type: 'select',
          options: companyTypeOptions,
          fieldProps: {
            disabled: !isNew
          }
        },
        {
          label: t('NAME'),
          id: 'NameEN',
          fieldProps: {
            disabled: !isNew
          }
        },
        {
          label: t('BC_TYPE'),
          type: 'select',
          options: addAllToOptions(t, bcTypeOptions),
          id: 'BCType'
        },
        {
          label: t('REF_CODE'),
          id: 'RefCode'
        },
        {
          label: t('NAME_TC'),
          id: 'NameTC'
        },
        {
          label: t('NAME_SC'),
          id: 'NameSC'
        },
        {
          label: t('ADDRESS_EN'),
          id: 'AddressEN'
        },
        {
          label: t('ADDRESS_TC'),
          id: 'AddressTC'
        },
        {
          label: t('ADDRESS_SC'),
          id: 'AddressSC'
        },
        {
          label: t('SORT'),
          id: 'Sort',
          fieldProps: {
            type: 'number'
          }
        },
        {
          label: t('ISDEFAULT'),
          id: 'IsDefault',
          type: 'checkbox'
        }
      ];
    case SETTING_TYPE.CONCRETE:
      return [
        {
          label: t('CONCRETE_GRADE'),
          id: 'Grade',
          fieldProps: {
            disabled: !isNew
          }
        },
        {
          label: t('SORT'),
          id: 'Sort',
          fieldProps: {
            type: 'number'
          }
        },
        {
          label: t('ISDEFAULT'),
          id: 'IsDefault',
          type: 'checkbox'
        }
      ];
    case SETTING_TYPE.VEHICLE:
      return [
        {
          label: t('LICENSE_PLATE_NO'),
          id: 'LicensePlateNo'
        },
        {
          label: t('GPS_DEVICE_ID'),
          id: 'GpsDeviceId'
        }
      ];
    case SETTING_TYPE.GPSHISTORY:
      return [
        {
          label: t('RFIDMODULEID'),
          id: 'RfidModuleId',
          type: 'combobox',
          // type: 'select',
          options: rifdList
        },
        {
          label: t('DEVICEID'),
          id: 'DeviceId'
        },
        {
          label: t('GPS_LAT'),
          id: 'GpsLat'
        },
        {
          label: t('GPS_LONG'),
          id: 'GpsLong'
        },
        {
          label: t('LEFTFACTORY'),
          id: 'LeftFactory',
          type: 'checkbox'
        },
        {
          label: t('ARRIVEDHK'),
          id: 'ArrivedHK',
          type: 'checkbox'
        },
        {
          label: t('ARRIVEDSITE'),
          id: 'ArrivedSite',
          type: 'checkbox'
        },
        {
          label: t('NOTIFIEDSITE'),
          id: 'NotifiedSite',
          type: 'checkbox'
        },
        {
          label: t('CREATED_DATE'),
          id: 'CreatedDate',
          type: 'dateTimePicker'
        }
      ];

    default:
      return [];
  }
};
